<template>
    <div class="main-betslip" :class="{ toggle: isToggle && $store.state.isScreenMobile }">
        <div class="betslip">
            <div class="betslip__empty" v-if="$store.state.cart.length === 0 && !$store.state.isScreenMobile">
                {{ getTranslatedText('cart empty') }}
            </div>
            <div class="betslip__body" v-else>
                <img
                    class="icon-close-betslip"
                    v-if="$store.state.isScreenMobile && isToggle"
                    :src="require(`@/public/theme/${themePath}/img/common/close-white.svg`)"
                    @error="handleImageError($event)"
                    @click="onToggleBetslip()"
                />
                <div class="betslip__header" @click="onToggleBetslip()">
                    <span class="betslip__header-title">{{ getTranslatedText('BETSLIP') }}</span>
                    <div class="betslip__header-quantity">{{ renderQuantity() }}</div>
                    <img
                        v-if="$store.state.isScreenMobile && !isToggle"
                        :src="require(`@/public/theme/${themePath}/img/common/arrow.png`)"
                        @error="handleImageError($event)"
                    />
                </div>
                <div class="betslip__empty" v-if="$store.state.cart.length === 0 && $store.state.isScreenMobile && isToggle">
                    {{ getTranslatedText('cart empty') }}
                </div>
                <div v-else class="betslip__header-content" :class="{ toggle: isToggle && $store.state.isScreenMobile }">
                    <div
                        class="betslip__header-tab"
                        v-if="visibleGamesCount"
                    >
                        <template v-for="(v, i) in listMenugames">
                            <template
                                v-if="
                                    (v.step === 1 && $store.state.isShow590) ||
                                    (v.step === 2 && $store.state.isShow645) ||
                                    (v.step === 3 && $store.state.isShow459) ||
                                    (v.step === 4 && $store.state.isShow545)
                                "
                            >
                            <div
                            class="betslip__header-tab-item"
                            :class="{ active: $store.state.stepCart === v.step }"
                            :key="i"
                            @click="() => onChangeTabBetslip(v.step)"
                            >
                                    {{ getTranslatedText(v.title) }}
                                    <div class="betslip__header-quantity">{{ renderQuantityCart(v.step) }}</div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <div class="betslip__empty" v-if="$store.state.cartRender.length === 0">
                        {{ getTranslatedText('cart empty') }}
                    </div>
                    <template v-else>
                        <div class="betslip__list">
                            <div class="betslip__item" :class="{ 'betslip__item--failed': value.failed }" v-for="(value, index) in $store.state.cartRender" :key="index">
                                <div class="betslip__item-header">
                                    <span class="betslip__text bold">
                                        {{ getTranslatedText(`${value.title}`) }}
                                        <span v-if="value.banker_option" class="betslip__text bets">
                                            ( {{ getTranslatedText(value.banker_option) }} )
                                        </span>
                                        <span v-if="value.market_option === 'last_7'" class="betslip__text bets">
                                            ( {{ getTranslatedText('last 7') }} )
                                        </span>
                                        <span v-if="value.market_option === 'double_chance'" class="betslip__text bets">
                                            ( {{ getTranslatedText('double_chance') }} )
                                        </span>
                                        <span class="betslip__text bets" v-if="value.bets > 1">
                                            ( {{ value.selectionCount }} {{ getTranslatedText('multiple') }} - {{ value.bets }} {{ getTranslatedText('combinations') }} )
                                        </span>
                                    </span>
                                    <span class="betslip__text">{{ value.eventName }}</span>
                                    <span class="betslip__text">{{ renderPrice(value.price) }}</span>
                                    <span v-if="value.failed" class="betslip__text betslip__text--failed">
                                        {{ getTranslatedText('failed to process') }}
                                    </span>
                                </div>
                                <div class="betslip__item-footer">
                                    <template v-if="value.banker_option">
                                        <!-- Banker mode: show groups separately with labels -->
                                        <div class="betslip__banker-display">
                                            <div class="betslip__banker-group" v-for="(group, groupIndex) in value.selection" :key="groupIndex">
                                                <span class="betslip__banker-label" v-if="groupIndex === 0">{{ getTranslatedText('banker balls') }}:</span>
                                                <span class="betslip__banker-label" v-else>{{ getTranslatedText('other balls') }}:</span>
                                                <div class="betslip__list-number">
                                                    <div class="betslip__item-number" v-for="(number, numIndex) in group" :key="numIndex" :class="{ 'banker-ball': groupIndex === 0 }">
                                                        <span class="betslip__text">{{ number }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <!-- Normal mode: show as single row -->
                                        <div class="betslip__list-number" v-for="(v, i) in value.selection" :key="i">
                                            <div class="betslip__item-number" v-for="(number, Numberindex) in v" :key="Numberindex">
                                                <span class="betslip__text">{{ number }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <img
                                        v-if="!$store.state.isScreenMobile"
                                        :src="require(`@/public/theme/${themePath}/img/common/close.svg`)"
                                        @error="handleImageError($event)"
                                        @click="onShowConfirmRemoveItem(value)"
                                    />
                                    <img
                                        v-else
                                        :src="require(`@/public/theme/${themePath}/img/common/close-white.svg`)"
                                        @error="handleImageError($event)"
                                        @click="onShowConfirmRemoveItem(value)"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="betslip__action">
                            <div class="betslip__action-total">
                                <span class="betslip__text">{{ getTranslatedText('total') }}</span>
                                <span class="betslip__text">{{ renderPrice(this.$store.state.totalCart) }}</span>
                            </div>
                            <div class="betslip__action-box-button">
                                <ButtonCommon :isNoHover="true" value="clear" :isLoading="isLoadingButton" nameFunction="on-show-confirm-betslip" />
                                <ButtonCommon type="error" :isNoHover="true" value="add" :isLoading="isLoadingButton" nameFunction="on-submit-transact" />
                            </div>
                        </div>
                    </template>
                </div>
                <div v-if="isToggle" class="betslip__footer" @click="onToggleBetslip()">
                    <span class="betslip__header-title">{{ getTranslatedText('BETSLIP') }}</span>
                    <div class="betslip__header-quantity">{{ $store.state.quantity }}</div>
                    <img
                        :src="require(`@/public/theme/${themePath}/img/common/arrow.png`)"
                        @error="handleImageError($event)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import EventBus from '@/utils/EventBus'
import gamesService from '@/services/games.service'
import languageMixins from '@/mixins/language/language-mixins'
import pathAssetsMixins from '@/mixins/pathAssets/path-assets-mixins'
import customDrawNamesMixin from '@/mixins/customDrawNames/custom-draw-names-mixin'
import ButtonCommon from '@/components/common/button/index.vue'

import { convertDate, formatDate, formatPrice, isArrayEmpty, isStrEmpty } from '@/utils/utils'
import { getToken } from '@/services/axios'
import { listMenugames } from '@/resources/listMenuGames'
import { CT_GAME_SLUG } from '@/constants/game'
import { CT_PLAYER_TYPE } from '@/constants/app'

const TIMEOUT_REPRINT = process.env.VUE_APP_TIMEOUT_REPRINT || 2000
const HIDDEN_REPRINT = process.env.VUE_APP_HIDDEN_REPRINT === 'true'
const CART_BETSLIP_MIN = parseInt(process.env.VUE_APP_CART_BETSLIP_MIN || 100)

export default {
    mixins: [languageMixins, pathAssetsMixins, customDrawNamesMixin],
    components: { ButtonCommon },
    props: {
        isLoadingPage: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isLoadingButton: false,
            isToggle: false,
            listMenugames,
            paramPrint: '',
        }
    },
    computed: {
        visibleGamesCount() {
            const { isShow590, isShow645, isShow545, isShow459 } = this.$store.state
            return [isShow590, isShow645, isShow545, isShow459].filter(Boolean).length
        }
    },
    created() {
        EventBus.$on('on-remove-item-betslip', (param) => this.onRemoveItem(param))
        EventBus.$on('on-show-confirm-betslip', () => this.onShowConfirmClear())
        EventBus.$on('on-clear-betslip', () => this.onClearBetslip())
        EventBus.$on('on-submit-transact', () => this.onSubmitTransact())
        EventBus.$on('on-toggle-betslip', () => this.onToggleBetslip())
        EventBus.$on('on-post-message-print', (param) => this.onPostMessagePrint(param))
    },
    destroyed() {
        EventBus.$off('on-remove-item-betslip')
        EventBus.$off('on-show-confirm-betslip', null)
        EventBus.$off('on-clear-betslip')
        EventBus.$off('on-submit-transact')
        EventBus.$off('on-toggle-betslip')
        EventBus.$off('on-post-message-print')
    },
    methods: {
        // action
        onShowConfirmClear() {
            const param = {
                title: "Confirmation",
                description: 'Are you sure you want to delete?',
                nameFunction: 'on-clear-betslip',
                textButtonSubmit: 'yes',
                paramFunction: {
                    isNotClosePopup: false,
                },
            }
            EventBus.$emit('on-show-dialog', param)
        },

        onShowConfirmRemoveItem(item) {
            const param = {
                title: "Confirmation",
                description: 'Are you sure you want to delete?',
                nameFunction: 'on-remove-item-betslip',
                textButtonSubmit: 'yes',
                paramFunction: {
                    item,
                    isNotClosePopup: false,
                },
            }
            EventBus.$emit('on-show-dialog', param)
        },

        onShowConfirmPrint() {
            const param = {
                title: 'CONFIRM PRINT',
                description: 'Are you sure you want to print this ticket',
                textButtonSubmit: 'yes',
                nameFunction: 'on-post-message-print',
                paramFunction: {
                    isNotClosePopup: false,
                },
            }
            EventBus.$emit('on-show-dialog', param)
        },

        onPostMessagePrint(popupParam) {
            let param = {
                isLoadingButton: true,
            }
            EventBus.$emit('on-change-value-dialog', param)

            const printData = this.paramPrint
            const isRePrint = popupParam?.isRePrint || false

            // Safety check: ensure printData exists and is not empty
            if (!printData || (typeof printData === 'string' && printData === '')) {
                console.warn('No print data available')
                return
            }

            // Create a single print data object that includes all transactions
            let dataPrint = {
                isRePrint: isRePrint
            }

            // Check if we have multiple transactions (array) or single transaction (object)
            if (Array.isArray(printData)) {
                // Multiple transactions - wrap them in a transactions array
                dataPrint.transactions = printData
            } else {
                // Single transaction - wrap in a transactions array for consistency
                dataPrint.transactions = [printData]
            }

            // Send single postMessage with all transaction data
            window.parent.postMessage({ action: 'print', data: JSON.stringify(dataPrint) }, '*')

            if (HIDDEN_REPRINT) {
                return
            }

            setTimeout(() => {
                const param = {
                    title: 'CONFIRM REPRINT',
                    description: 'This ticket was already printed. Do you want to reprint it',
                    nameFunction: 'on-post-message-print',
                    textButtonCancel: 'CANCEL',
                    textButtonSubmit: 'REPRINT',
                    isLoadingButton: false,
                    paramFunction: {
                        isRePrint: true,
                        isNotClosePopup: true,
                    },
                }
                EventBus.$emit('on-change-value-dialog', param)
            }, TIMEOUT_REPRINT)
        },

        onRemoveItem(param) {
            const payload = {
                item: param.item,
            }
            this.$store.dispatch('onRemoveItemCart', payload)
        },

        onClearBetslip() {
            this.$store.dispatch('onClearCart')
        },

        onToggleBetslip() {
            if (this.$store.state.isScreenMobile) {
                this.isToggle = !this.isToggle
                EventBus.$emit('on-toggle-betslip-mobile', this.isToggle)
            }
        },

        onChangeTabBetslip(step) {
            const payload = {
                step,
            }
            this.$store.dispatch('onSwitchBetslip', payload)
        },

        renderQuantity() {
            let { isShow590, isShow645, isShow459, isShow545, quantity, cart } = this.$store.state

            let quantityRender = quantity

            if(quantityRender > 0) {
                if (!isShow590) quantityRender -= cart.filter((x) => x.gameType === 'loto-590').length
                if (!isShow645) quantityRender -= cart.filter((x) => x.gameType === 'lotto-6-45').length
                if (!isShow459) quantityRender -= cart.filter((x) => CT_GAME_SLUG.LOTTO_459.includes(x.gameType?.toLowerCase())).length
                if (!isShow545) quantityRender -= cart.filter((x) => x.gameType === 'lotto-5-45').length
            }
      
            return quantityRender
        },

        renderQuantityCart(step) {
            let type = 'Loto 4/59'

            if (step === 1) {
                type = 'loto-590'
            } else if (step === 2) {
                type = 'lotto-6-45'
            } else if (step === 3) {
                type = 'loto-4-59-luckia'
            } else {
                type = 'lotto-5-45'
            }

            let cartRender = this.$store.state.cart.filter((x) => x.gameType === type)
            return cartRender.length
        },

        onShowStatusTransact(code, message, shouldClearCart = true) {
            if (code === 200) {
                const param = {
                    text: message || this.getTranslatedText('transaction completed!'),
                    type: 'success',
                }
                EventBus.$emit('show-notications', param)
                if (shouldClearCart) {
                    this.$store.dispatch('onClearCart')
                }

                this.isLoadingButton = false
            } else if (code === 207) {
                // Partial success - show as warning/info
                const param = {
                    text: message || this.getTranslatedText('system error!'),
                    type: 'warning',
                }
                EventBus.$emit('show-notications', param)
                this.isLoadingButton = false
            } else {
                const param = {
                    text: message || this.getTranslatedText('system error!'),
                    type: 'error',
                }
                EventBus.$emit('show-notications', param)
                this.isLoadingButton = false
            }
        },

        async onSubmitTransact() {
            try {
                this.isLoadingButton = true
                
                // Validate minimum betslip total
                const totalCart = parseFloat(this.$store.state.totalCart) || 0
                if (totalCart < CART_BETSLIP_MIN) {
                    let errorMessage = this.getTranslatedText('betslip/panier is < [min] and min is [min]', {
                        min: CART_BETSLIP_MIN
                    })
                    // Replace all occurrences of [min] since getTranslatedText only replaces first occurrence
                    errorMessage = errorMessage.replace(/\[min\]/g, CART_BETSLIP_MIN)
                    const param = {
                        text: errorMessage,
                        type: 'error',
                    }
                    EventBus.$emit('show-notications', param)
                    this.isLoadingButton = false
                    return
                }
                
                const token = getToken()
                if (!isStrEmpty(token && this.$store.state.isLogin)) {
                    const { stepCart, transact, transact645, transact459, transact545 } = this.$store.state
                    let payload = []

                    if (stepCart === 1) {
                        payload = transact
                    } else if (stepCart === 2) {
                        payload = transact645
                    } else if (stepCart === 3) {
                        payload = transact459
                    } else {
                        payload = transact545
                    }

                    payload.forEach((item) => {
                        delete item.id
                        // For combination or banker bets, force wager to 50
                        if (item.combination_play === 1) {
                            item.wager = 50
                        }
                    })

                    let isMultiLotto = stepCart === 1
                    let type = isMultiLotto ? 'multi-lotto' : 'pari-mutuel-lotto'

                    const resp = await gamesService.transactLotto(payload, type)

                    // Handle V2 response format (with summary and transactions array)
                    if (resp.code === 200 || resp.code === 207) {
                        console.log('Transact Response:', resp)
                        // V2 format: { code: 200/207, data: { summary: {...}, transactions: [...] } }
                        if (resp.data && resp.data.transactions && Array.isArray(resp.data.transactions)) {
                            // Separate successful and failed transactions, preserving original indices
                            const successfulTransactions = []
                            const failuresTransaction = []
                            
                            resp.data.transactions.forEach((tx, originalIndex) => {
                                if (tx.code === 200) {
                                    successfulTransactions.push({ ...tx, originalIndex })
                                } else {
                                    failuresTransaction.push({ ...tx, originalIndex })
                                }
                            })
                            
                            const allSuccessful = failuresTransaction.length === 0
                            
                            // Build comprehensive message for partial success
                            let message = ''
                            const summary = resp.data.summary || {}
                            
                            if (allSuccessful) {
                                // All successful - translate the API message if it's in "PROCESSED X SUCCESSFUL, Y FAILED" format
                                if (resp.message) {
                                    const match = resp.message.match(/PROCESSED\s+(\d+)\s+SUCCESSFUL,\s+(\d+)\s+FAILED/i)
                                    if (match) {
                                        message = this.getTranslatedText('processed [success] successful, [failed] failed', {
                                            success: match[1],
                                            failed: match[2]
                                        })
                                    } else {
                                        message = resp.message
                                    }
                                } else {
                                    message = this.getTranslatedText('transaction completed')
                                }
                                this.onShowStatusTransact(200, message)
                            } else {
                                // Partial success - build simplified message
                                const successfulCount = summary.successful || successfulTransactions.length
                                const failedCount = summary.failed || failuresTransaction.length
                                
                                // Summary line: "2 FAILED, 1 passed"
                                message = `${failedCount} ${this.getTranslatedText('failed')}, ${successfulCount} ${this.getTranslatedText('successful')}\n\n`
                                
                                // Add failed entries details - simplified: just bet number and draw
                                if (failuresTransaction.length > 0) {
                                    message += `${this.getTranslatedText('failed')}:\n`
                                    failuresTransaction.forEach((failure) => {
                                        const lineNumber = failure.failed_entry?.line || (failure.originalIndex + 1)
                                        const gameName = failure.failed_entry?.game || ''
                                        message += `  ${this.getTranslatedText('bet')} #${lineNumber}${gameName ? ` - ${gameName}` : ''}\n`
                                    })
                                }
                                
                                // Add successful entries count
                                if (successfulTransactions.length > 0) {
                                    message += `\n${successfulCount} ${this.getTranslatedText('successful')} ✓`
                                }
                                
                                // Pass message as pre-translated since it contains newlines and is already translated
                                const param = {
                                    text: message,
                                    type: 'warning',
                                }
                                EventBus.$emit('show-notications', param)
                                this.isLoadingButton = false
                                
                                // Update cart: mark failed items, remove successful ones
                                const failedEventIds = failuresTransaction.map(f => f.failed_entry?.event_id?.[0]).filter(Boolean)
                                const successfulEventIds = successfulTransactions.map(s => {
                                    const entry = s.data?.bets?.entries?.[0]
                                    return entry?.event?.eventId
                                }).filter(Boolean)
                                
                                this.$store.dispatch('onPartialTransactResult', {
                                    failedEventIds,
                                    successfulEventIds,
                                    stepCart
                                })
                            }
                            
                            // Store all successful transactions for print (each transaction with its own bet)
                            if (successfulTransactions.length > 0) {
                                if (successfulTransactions.length === 1) {
                                    // Single transaction - use as is
                                    this.paramPrint = successfulTransactions[0]?.data || successfulTransactions[0]
                                } else {
                                    // Multiple transactions - store as array, each transaction with its own bet
                                    this.paramPrint = successfulTransactions.map(tx => tx.data || tx)
                                }
                                
                                // Show print dialog only if there are successful transactions
                                if(this.$store.state.playerType === CT_PLAYER_TYPE.RETAIL) {
                                    this.onShowConfirmPrint()
                                }
                            }
                            
                            // Clear cart only if all transactions succeeded
                            if (allSuccessful) {
                                this.$store.dispatch('onClearCart')
                            }
                        } else {
                            // Old format: { code: 200, data: { transaction: {...}, bets: {...} } }
                            this.onShowStatusTransact(200, resp.message || this.getTranslatedText('transaction completed'))
                            this.paramPrint = resp.data
                            
                            if(this.$store.state.playerType === CT_PLAYER_TYPE.RETAIL) {
                                this.onShowConfirmPrint()
                            }
                        }
                        
                        parent.postMessage({ command: 'refreshbalance' }, '*')
                    } else {
                        console.log('Transact Error Response:', resp)
                        // Translate common error messages
                        let message = resp.message
                        if (message) {
                            // Try to translate the error message (convert to lowercase for matching)
                            const messageLower = message.toLowerCase()
                            const translatedMessage = this.getTranslatedText(messageLower)
                            // If translation exists and is different from key, use it; otherwise use original
                            message = (translatedMessage && translatedMessage !== messageLower) ? translatedMessage : message
                        }
                        this.onShowStatusTransact(401, message)
                    }
                } else {
                    const param = {
                        text: this.getTranslatedText('please login!'),
                        type: 'error',
                    }
                    EventBus.$emit('show-notications', param)
                }
            } catch (error) {
                console.log(error)
            } finally {
                this.isLoadingButton = false
            }
        },

        // format
        renderDate(date) {
            const dateFormat = formatDate(convertDate(date))

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour24h}:${dateFormat.minutes}`

            return valueDate
        },

        renderPrice(price) {
            return formatPrice(price)
        },

        handleImageError(event) {
            // Prevent infinite loop by checking if we've already tried the fallback
            if (event.target && !event.target.dataset.fallbackTried) {
                const currentSrc = event.target.src
                // Try fallback to default theme if current theme failed
                if (this.themePath !== 'default' && currentSrc.includes(this.themePath)) {
                    event.target.dataset.fallbackTried = 'true'
                    const fallbackSrc = currentSrc.replace(`/${this.themePath}/`, '/default/')
                    event.target.src = fallbackSrc
                } else {
                    // If already tried fallback or no fallback available, hide the image
                    event.target.style.display = 'none'
                }
            } else if (event.target) {
                // Already tried fallback, hide the image to prevent infinite loop
                event.target.style.display = 'none'
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/layouts/_betslip.scss';
</style>
